<template>
  <main-layout>
    <div>
      <check-circle
        scale="3"
        color="red"
      />
    </div>

    <h1 class="text-3xl bold">
      {{ $t('recurrence.cancel.confirmedTitle') }}
    </h1>

    <p
      class="text-xl"
    >
      {{ $t('recurrence.cancel.confirmedText') }}
    </p>
    <button
      id="goBack"
      class="button"
      @click="goBack"
    >
      Finalizar
    </button>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/MainLayout';
import { CheckCircle } from '@/components/icons';

export default {
  name: 'CancelRecurrenceConfirmed',
  components: { MainLayout, CheckCircle },
  methods: {
    goBack() {
      this.$router.push({ name: 'SetNumber' });
    }
  }
};
</script>
